{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Färgväljaren",
  "twoDimensionalSlider": "2D-reglage",
  "colorSwatch": "color swatch",
  "transparent": "transparent"
}
